import {
    List, Datagrid, TextField, DateField, FunctionField,
    Edit, SimpleForm, TextInput, SelectInput,
    Create, ReferenceArrayInput, SelectArrayInput,
    TopToolbar, ListButton,
} from 'react-admin';
import { Chip } from '@mui/material';

// Anwendungen (Produkt-Familien) — muss App\Config\Applications im SSO entsprechen.
export const APPLICATION_CHOICES = [
    { id: 'academy', name: 'online:academy' },
    // Brand-Schreibweise wie online:academy: klein mit Doppelpunkt
    // (Agentur-Feedback 2026-08-17). Technischer Key bleibt `azubiweb`.
    { id: 'azubiweb', name: 'azubi:web' },
];

const applicationLabel = (application?: string | null) =>
    APPLICATION_CHOICES.find((c) => c.id === application)?.name;

export const ApplicationField = () => (
    <FunctionField
        source="application"
        render={(record: any) =>
            record?.application
                ? <Chip label={applicationLabel(record.application) ?? record.application} size="small" variant="outlined" />
                : <Chip label="Global" size="small" />
        }
    />
);

const roleFilters = [
    <TextInput key="name" source="name" alwaysOn />,
    <SelectInput key="application" source="application" choices={APPLICATION_CHOICES} alwaysOn />,
];

export const RoleList = () => (
    <List filters={roleFilters}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="description" />
            <ApplicationField />
            <DateField source="createdAt" />
        </Datagrid>
    </List>
);

export const RoleEdit = () => (
    <Edit actions={<TopToolbar><ListButton /></TopToolbar>}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="description" multiline />
            <SelectInput source="application" choices={APPLICATION_CHOICES} emptyText="Global (alle Produkte)" />
            <ReferenceArrayInput source="permissions" reference="permissions" sort={{ field: 'name', order: 'ASC' }}>
                <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
        </SimpleForm>
    </Edit>
);

export const RoleCreate = () => (
    <Create actions={<TopToolbar><ListButton /></TopToolbar>}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="description" multiline />
            <SelectInput source="application" choices={APPLICATION_CHOICES} emptyText="Global (alle Produkte)" />
            <ReferenceArrayInput source="permissions" reference="permissions" sort={{ field: 'name', order: 'ASC' }}>
                <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
        </SimpleForm>
    </Create>
);
